import React, { useState } from "react";
import SideBar from "../../components/sidebar/SideBar";
import AboutImg from "../../assets/images/Abouttool.png";
import { SlArrowDown } from "react-icons/sl";

import "./About.scss";

function About() {
  const [toggleContent, setToggleContent] = useState();

  const handleToggleContent = (index) => {
    setToggleContent((prevIndex) => (prevIndex === index ? null : index));
  };

  const contentList = [
    {
      title: "1. Strategic Insight",
      content: (
        <>
          <p>
            Digi-Cadence dives deep into your brand's digital strategy to ensure
            it aligns with your overarching business goals and objectives. This
            section evaluates your vision, innovation capacity, and
            customer-centric focus.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">
                Vision & Leadership Alignment:
              </span>
              Analyze how effectively your digital strategies reflect the
              leadership's vision and long-term business goals.
            </li>
            <li>
              <span className="bold-text-title">
                Innovation & Digital Investments:
              </span>
              Measure your brand's investment in emerging technologies and
              innovative digital solutions that drive a competitive edge.
            </li>
            <li>
              <span className="bold-text-title">
                Customer-Centric Strategy:
              </span>
              Evaluate how well your digital strategies improve customer
              engagement, experience, and satisfaction.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            Strategic alignment is key to maximizing the impact of digital
            initiatives. Digi-Cadence helps ensure that your digital efforts
            contribute directly to your long-term business success, creating a
            foundation for scalable growth.
          </p>
        </>
      ),
    },
    {
      title: "2. Comprehensive Capabilities Assessment",
      content: (
        <>
          <p>
            Digi-Cadence assesses the various capabilities that form the
            backbone of your brand's digital infrastructure. From technology to
            analytics and content performance, Digi-Cadence offers a thorough
            evaluation of your digital capabilities.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">
                Technology Stack & Infrastructure:
              </span>
              An in-depth audit of your current digital tools and platforms,
              assessing their effectiveness and scalability.
            </li>
            <li>
              <span className="bold-text-title">
                Data Analytics & Decision Making:
              </span>
              Review how effectively your brand leverages data to inform
              strategies, personalize customer experiences, and drive business
              decisions.
            </li>
            <li>
              <span className="bold-text-title">
                Content & Channel Performance:
              </span>
              Measure the effectiveness of your digital content and distribution
              across various channels, ensuring it resonates with your target
              audience.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            Having the right digital infrastructure and data-driven
            decision-making capabilities is critical for sustained success.
            Digi-Cadence ensures your technology, content, and data utilization
            are optimized to drive performance and improve outcomes with respect
            to your competitors.
          </p>
        </>
      ),
    },
    {
      title: "3. Digital Culture & Execution",
      content: (
        <>
          <p>
            In a rapidly evolving digital landscape, organizational agility and
            collaboration are essential. Digi-Cadence evaluates how your
            internal teams and culture support digital execution and
            adaptability.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">Agility & Adaptability:</span>
              Evaluate how quickly and efficiently your organization responds to
              new digital opportunities and market changes.
            </li>
            <li>
              <span className="bold-text-title">
                Collaboration & Cross-Functional Teams:
              </span>
              Assess how well your teams collaborate on digital initiatives and
              align efforts across departments.
            </li>
            <li>
              <span className="bold-text-title">
                Skillset & Talent Mapping:
              </span>
              Identify gaps in the digital skill sets of your workforce and
              highlight areas where new talent or training may be needed.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            A digitally mature organization is one that fosters a culture of
            agility, collaboration, and continuous learning. Digi-Cadence helps
            ensure your teams are equipped with the skills and mindset needed to
            execute digital strategies effectively.
          </p>
        </>
      ),
    },
    {
      title: "4. Customer Journey Optimization",
      content: (
        <>
          <p>
            A seamless and well-orchestrated customer journey is essential for
            success in the digital age. Digi-Cadence assesses the quality of
            your customer interactions across digital touchpoints and provides
            insights to refine the customer experience.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">
                Journey Mapping & Optimization:
              </span>
              Evaluate how well your brand manages the customer journey, from
              awareness to conversion, and identify areas for optimization.
            </li>
            <li>
              <span className="bold-text-title">Touchpoint Effectiveness:</span>
              Assess the quality of engagement at each stage of the customer
              journey and how digital touchpoints contribute to a cohesive brand
              experience.
            </li>
            <li>
              <span className="bold-text-title">
                Personalization & Automation:
              </span>
              Review your capabilities in delivering personalized experiences
              and leveraging automation to streamline customer interactions.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            A well-optimized customer journey is key to driving conversions and
            building loyalty. Digi-Cadence helps you create a frictionless
            customer experience, leading to higher engagement and improved
            satisfaction.
          </p>
        </>
      ),
    },
    {
      title: "5. Benchmarking & Scoring",
      content: (
        <>
          <p>
            One of Digi-Cadence's standout features is its ability to generate a
            **Digi-Cadence Score (DC Score)** that serves as a clear, actionable
            benchmark for your digital maturity. By evaluating over 100+
            critical metrics, the tool provides a comprehensive view of your
            digital standing.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">DC Score:</span>A clear and
              concise score reflecting your brand's overall digital maturity
              based on strategy, execution, capabilities, and culture.
            </li>
            <li>
              <span className="bold-text-title">Competitor Benchmarking:</span>
              Compare your DC Score against industry standards and competitors,
              providing you with context and clarity on how to improve.
            </li>
            <li>
              <span className="bold-text-title">Gap Analysis:</span>
              Identify the most critical gaps in your digital strategy and
              execution to prioritize areas of improvement for the greatest
              business impact.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            Understanding where you stand is the first step toward improvement.
            Digi-Cadence's DC Score and competitor benchmarking offer clarity,
            empowering brands to make data-driven decisions and stay ahead of
            the competition.
          </p>
        </>
      ),
    },
    {
      title: "6. Continuous Improvement",
      content: (
        <>
          <p>
            Digital transformation is an ongoing process, and Digi-Cadence
            ensures your brand never stops evolving. The tool offers continuous
            insights to guide future digital initiatives, ensuring long-term
            success.
          </p>
          <p className="bold-text-title">Key Metrics:</p>
          <ul>
            <li>
              <span className="bold-text-title">Actionable Insights:</span>
              Receive specific recommendations on where to focus your efforts
              for maximum digital growth.
            </li>
            <li>
              <span className="bold-text-title">Trend Monitoring:</span>
              Stay up to date with the latest digital trends and ensure your
              brand evolves with changing market dynamics.
            </li>
            <li>
              <span className="bold-text-title">Performance Tracking:</span>
              Track your DC Score over time to measure progress and continuously
              refine your digital strategy.
            </li>
          </ul>
          <p className="bold-text-title">Why It Matters:</p>
          <p>
            The digital landscape is ever-evolving, and maintaining a
            competitive edge requires continuous effort. Digi-Cadence empowers
            your brand to stay ahead by constantly adapting and optimizing your
            digital initiatives.
          </p>
        </>
      ),
    },
  ];
  console.log("content", contentList);
  return (
    <>
      <div className="col-12">
        <div className="workspace-container">
          <h2 className="page-title d-flex justify-content-center mt-4 ml-3">
            Digi-Cadence: Comprehensive Digital Tool
          </h2>
          <h3 className="intro-highlights">
            "In the digital race, those who measure grow faster. Discover where
            your brand stands today and take the first step towards future
            digital excellence with Digi-Cadence."
          </h3>
          <div className="row">
            <div className="col-md-12 col-lg-6">
              <span className="section-title">Introduction</span>
              <p>
                Digi-Cadence is a robust digital maturity tool designed to
                evaluate, analyze, and benchmark your brand's digital presence
                and capabilities. By measuring over 100+ critical metrics across
                various digital touchpoints, Digi-Cadence provides brands with a
                detailed Digital Cadence Score that offers actionable insights.
                This score helps identify where your brand stands in terms of
                digital strategy, execution, and culture while benchmarking your
                performance against competitors and industry standards.
              </p>
              <p>
                The tool is designed to guide brands toward excellence by
                pinpointing strengths, uncovering gaps, and helping craft a
                clear roadmap for continuous digital growth.
              </p>
              {contentList.map((item, index) => (
                <div key={index} className="key-container">
                  <span
                    className={`section-title-text ${
                      toggleContent === index ? "toggle-show" : "toggle-hide"
                    }`}
                    onClick={() => handleToggleContent(index)}
                  >
                    {item.title}{" "}
                    <SlArrowDown
                      className={
                        toggleContent === index
                          ? "icon-up-arrow"
                          : "icon-down-arrow"
                      }
                    />
                  </span>
                  {toggleContent === index && (
                    <div className="toggle-content">{item.content}</div>
                  )}
                </div>
              ))}
            </div>
            <div className="col-md-12 col-lg-6">
              <img src={AboutImg} alt="About Tool" className="responsive-img" />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p>
                Digi-Cadence is your ultimate tool to assess, benchmark, and
                accelerate your brand's digital transformation journey. By
                offering deep insights into digital strategy, capabilities, and
                execution, Digi-Cadence provides the clarity needed to elevate
                your brand in a competitive digital landscape.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
